import logo from './logo.svg';
import GameModeButton from './components/GameModeButton';
import GhostIcon from './components/GhostIcon';
import CameraIcon from './components/CameraIcon';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import YourStats from './components/YourStats';

function App() {

  return (
    <ErrorBoundary>
      <div className="App">
        <div className="app-title">
          <h1>Phasmodle</h1>
          <p>Your daily dose of ghost hunting</p>
        </div>
        <div className="gamemode-buttons-container">
          <GameModeButton icon={<GhostIcon classes={"gamemode-icon"} color="#ff0000"/>} title="Ghost Hunting" description="Guess today’s ghost based on the evidence" url="/ghost" color={"neon-red"} />
          <GameModeButton icon={<CameraIcon classes={"gamemode-icon"} color="#8B00FF"/>} title="Room Guesser" description="Guess the room from a random map based on a picture" url="/room" color={"neon-violet"}/>
        </div>
        <ErrorBoundary>
          <YourStats/>
        </ErrorBoundary>
      </div>
    </ErrorBoundary>
  );
}

export default App;
